<template>
        <div class="pagination">
            <button
            type="button"
            class="pre-page"
            :class="{'disable': isInFirstPage}"
            @click="onClickPreviousPage"
            :disabled="isInFirstPage"
            >
           &lt;
            </button>

            <a
            href="#"
            v-for="page in pages"
            :key="page.name"
            class="page-link"
            @click.prevent="!isPageActive(page.name) && onClickPage(page.name)"
            :class="{ 'page-link--current': isPageActive(page.name) }"
            >
            {{ page.name }}
            </a>

            <button
            type="button"
            class="next-page"
            :class="{'disable': isInLastPage}"
            @click="onClickNextPage"
            :disabled="isInLastPage"
            >
            &gt;
            </button>
        </div>
</template>

<script>
import { ref, computed } from 'vue';
export default {
    name: "PaginationBox",
    props: {
        pageCount: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
    },
    emits: ['pageChanged'],
    setup(props, { emit }) {
        const maxVisibleButtons = ref(3);
        const isInFirstPage = computed(() => props.currentPage === 1);
        const isInLastPage = computed(() => props.currentPage === props.pageCount);

        const startPage = computed(() => {
            if (props.currentPage === 1) return 1;

            if (props.currentPage === props.pageCount)
            return Math.max(props.pageCount - maxVisibleButtons.value + 1, 1);

            return props.currentPage - 1;
        });

        const pages = computed(() => {
            const range = [];
            const from = startPage.value;
            const to = Math.min(from + maxVisibleButtons.value - 1, props.pageCount);
            for (let i = from; i <= to; i++) {
                range.push({
                    name: i,
                });
            }
            return range;
        });

        const onClickPreviousPage = () => emit('pageChanged', props.currentPage - 1);
        const onClickPage = (page) => emit('pageChanged', page);
        const onClickNextPage = () => emit('pageChanged', props.currentPage + 1);

        const isPageActive = (page) => props.currentPage === page;

        return {
        isInFirstPage,
        isInLastPage,
        pages,
        onClickPreviousPage,
        onClickPage,
        onClickNextPage,
        isPageActive,
        };
    },
};
</script>

<style>

.pagination {
    display: flex;
    gap: 12px;
}

.pagination >* {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pagination button {
    background-color: var(--main-pink);
    color: #ffffff;
    border: none;
    cursor: pointer;
    border-radius: 6px;
}

.pagination button:hover {
    box-shadow: 0 0 10px var(--shadow-pink);
}

.disable {
    opacity: 50%;
}

.pagination button.disable:hover {
    box-shadow: none !important;

}

.pre-page {
    margin-left: 12px;
}

.next-page {
    margin-right: 12px;
}

.page-link {
    color: #323232;
    font-size: 14px;
    font-family: IRANYekan-Medium;
}

.page-link:hover,
.page-link:active,
.page-link--current {
    background-color: var(--main-pink);
    color: #ffffff;
    font-family: IRANYekan-Bold;
    border-radius: 6px;
}

</style>
